import React, { useState } from 'react';
import { MobileDrawBudgetCategory } from './components/MobileDrawBudgetCategory';
import { MobileDrawBudgetItem } from './components/MobileDrawBudgetItem/MobileDrawBudgetItem';
import { DrawBudgetLineCategory, DrawBudgetLineCategories } from '@apply/constants';
import { MobileDrawItem } from '../../types/MobileDrawItem';
import { IDrawBudget } from '@apply/api/src/api/DrawApi';

interface MobileDrawDetailsParameters {
    drawBudget?: IDrawBudget;
    mobileDrawItems: MobileDrawItem[];
    hideFullyFunded: boolean;
    set_mobileBorrowerRequest: (drawItemId: number, borrowerRequest: number) => void;
}

export const MobileDrawDetails: React.FC<MobileDrawDetailsParameters> = ({
    drawBudget,
    mobileDrawItems,
    hideFullyFunded,
    set_mobileBorrowerRequest,
}) => {
    if (!mobileDrawItems) return;

    const categories = [...new Set(mobileDrawItems.map((item) => item.categoryId))];
    const [drawItemCalculationMetric, set_drawAmountCalculationMetric] = useState('percent');

    const availableAmountByCategory = (category: DrawBudgetLineCategory) => {
        const categoryAvailable = mobileDrawItems
            .filter((item) => item.categoryId == category)
            ?.reduce((sum, value) => (sum += value?.availableAmount ?? 0), 0);
        return categoryAvailable;
    };

    return categories.map((category) => (
        <div
            className={`mobileBudgetCategory ${availableAmountByCategory(category) <= 0 && hideFullyFunded ? 'hidden' : ''}`}
            key={category}
        >
            <MobileDrawBudgetCategory
                key={`budgetCategory${category}`}
                header={
                    <h5>
                        {
                            DrawBudgetLineCategories.find((c) => c.id == category)?.loanTypeMetadata.find(
                                (m) => m.type == drawBudget?.loanTypeId
                            )?.description
                        }
                    </h5>
                }
            >
                <div className='mobileBudgetItemList'>
                    {mobileDrawItems
                        .filter((i) => i.categoryId == category)
                        .map((item) => (
                            <MobileDrawBudgetItem
                                key={`budgetItem${item.description}`}
                                mobileDrawItem={item}
                                set_mobileBorrowerRequest={set_mobileBorrowerRequest}
                                hideFullyFunded={hideFullyFunded}
                                drawItemCalculationMetric={drawItemCalculationMetric}
                                set_drawAmountCalculationMetric={set_drawAmountCalculationMetric}
                            />
                        ))}
                </div>
            </MobileDrawBudgetCategory>
        </div>
    ));
};
